(() => {
  /**
   * Assumptions about your store base currency:
   * - Europe rule: EXCHANGE_RATE_EUR = 1.1 means 1 EUR = 1.1 BASE
   *   => BASE -> EUR = amount / 1.1
   *
   * - UAE rule: AED_RATE = 3.7 means 1 BASE = 3.7 AED
   *   => BASE -> AED = amount * 3.7
   *   and add 5% before converting.
   *
   * If your base currency differs (not USD, etc.), adjust these rates/directions.
   */

  const EXCHANGE_RATE_EUR = 4.4 ; // 1 EUR = 4.4 BASE
  const AED_RATE = 3.67;           // 1 USD = 3.6725 AED Pegeged to the dollar // Lower is more in USD
  const UAE_MARKUP = 0.05;       // +5%

  // Adjust selectors to match your theme
  //const MONEY_SELECTORS = ['.money', '[data-money]', '.price', '.f-price-item', '.sf-currency'];
  const MONEY_SELECTORS = ['.money', '[data-money]', '.price', '.f-price', '.sf-currency', '.price-round'];

  // EU/EEA-ish practical list (you can add/remove)
  const EUROPE_COUNTRIES = new Set([
    'NL','DE','BE','FR','ES','IT','PT','IE','AT','GR','FI','SE','DK',
    'PL','CZ','SK','HU','RO','BG','HR','SI','EE','LV','LT','LU','MT','CY',
    'NO','IS','LI','CH','EUROPE' // include if you also want these to see EUR formatting
  ]);

  const getCountryCode = () => {
    const c = (window.__VISITOR_COUNTRY__ || '').toString().trim().toUpperCase();
    return c || null;
  };

  const formatMoney = (value, currency) => {
    // Choose a locale that formats nicely for the target currency:
    const locale = currency === 'EUR' ? 'nl-NL' : currency === 'AED' ? 'en-AE' : 'en-US';


  if (currency === 'AED') {
    return new Intl.NumberFormat(locale, {
      style: 'currency',
      currency,
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
      currencyDisplay: 'code'
    })
      .format(value)
      .replace('AED', '').trim() + ' AED';
  }

    return new Intl.NumberFormat(locale, { style: 'currency', currency }).format(value);
  };

  const parsePriceFromText = (text) => {
    if (!text) return null;

    // Keep digits and separators, strip currency symbols/words
    let cleaned = text.trim().replace(/[^\d.,-]/g, '');

   // Remove any dots before the first number
    cleaned = cleaned.replace(/^\.*(?=\d)/, '');

    // If both separators exist, treat the last one as decimal
    const hasDot = cleaned.includes('.');
    const hasComma = cleaned.includes(',');

    if (hasDot && hasComma) {
      const lastDot = cleaned.lastIndexOf('.');
      const lastComma = cleaned.lastIndexOf(',');
      const decimalSep = lastDot > lastComma ? '.' : ',';
      const thousandSep = decimalSep === '.' ? ',' : '.';

      cleaned = cleaned.split(thousandSep).join('');
      cleaned = cleaned.replace(decimalSep, '.');
    } else if (hasComma && !hasDot) {
      // If comma looks like decimal (two digits after), convert to dot; else remove commas
      const parts = cleaned.split(',');
      if (parts.length === 2 && parts[1].length === 2) cleaned = parts[0].replace(/\./g, '') + '.' + parts[1];
      else cleaned = cleaned.replace(/,/g, '');
    } else {
      // dot or none: remove commas as thousands
      cleaned = cleaned.replace(/,/g, '');
    }

    // Temp fix for (72.00.72.00)
    cleaned = cleaned.replace(/^(\d+(\.\d+)?).*/, '$1');

    const num = Number(cleaned);
    return Number.isFinite(num) ? num : null;
  };

    // ---- Rounding helpers ----
    const roundUpEUR = (value) => {
    // Nearest whole euro, always up
    return Math.ceil(value);
    };

    const roundUpAED = (value) => {
    // Nearest 5 AED, always up
    return Math.ceil(value / 5) * 5;
    };

    const roundUpAll = (value, round) => {
    // Nearest 5 AED, always up
      return Math.ceil(value / round) * round;
    };

  // Conversion rules
    const convertForEurope = (baseAmount) => {
    const eur = baseAmount / EXCHANGE_RATE_EUR;
    return {
        currency: 'EUR',
        value: roundUpEUR(eur)
    };
    };

    const convertForUAE = (baseAmount) => {
    return {
        currency: 'AED',
        value: baseAmount
    };
    };

    const convertForAll = (baseAmount, round) => {
    // const markedUp = baseAmount * (1 + UAE_MARKUP);
    const aed = baseAmount / AED_RATE;
    return {
        //currency: 'AED',
        //value: roundUpAED(aed)
        currency: 'USD',
        value: roundUpAll(aed, round)
    };
    };

  const shouldConvert = (country) => {
    if (!country) return { mode: 'NONE' };
    if (country === 'AE') return { mode: 'UAE' };
    //if (EUROPE_COUNTRIES.has(country)) return { mode: 'EUROPE' };
    return { mode: 'NONE' };
  };

  const convertElement = (el, mode) => {
    if (!el) return;

    // Prevent double conversion
    if (el.dataset.geoConverted === 'true') return;

    round = 1;
    if (el.classList.contains('price-round')) {
      round = 5;
    }

    const originalText = el.textContent;
    let baseAmount = parsePriceFromText(originalText);
    if (baseAmount == null) return;
    //const baseAmount = 5;
  
    if (el.classList.contains('announce-price') && mode != 'UAE') {
      baseAmount = 733;
    }


    let out;
    if (mode === 'EUROPE') out = convertForEurope(baseAmount);
    else if (mode === 'NONE') out = convertForAll(baseAmount, round);
    else if (mode === 'UAE') out = convertForUAE(baseAmount);
    else return;

    //el.getAttributeNames().forEach(name =>
    //  el.removeAttribute(name)
    //);
    //el.setAttribute('data-original-money', originalText);
    el.textContent = formatMoney(out.value, out.currency);
    el.dataset.geoConverted = 'true';
    el.dataset.geoCurrency = out.currency;
  };

  const convertAll = (mode, root = document) => {
    const selector = MONEY_SELECTORS.join(',');
    root.querySelectorAll(selector).forEach((el) => convertElement(el, mode));
  };

function observeCartSubtotal(mode) {
  const PRICE_SEL = '[data-cart-subtotal-price]';
  const WRAP_SEL  = '[data-cart-subtotal]';

  let lastText = '';
  let scheduled = false;

  const schedule = () => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => {
      scheduled = false;

      const priceEl = document.querySelector(PRICE_SEL);
      if (!priceEl) return;

      const text = priceEl.textContent.trim().replace(/\s+/g, ' ');
      if (text && text !== lastText) {
        lastText = text;
        // Convert only within totals area (fast) – fallback to whole doc
        const wrap = priceEl.closest(WRAP_SEL) || document;
        convertAll(mode, wrap);
      }
    });
  };

  // Observe the subtotal wrapper if it exists; otherwise observe document until it appears
  const attach = () => {
    const wrap = document.querySelector(WRAP_SEL);
    if (!wrap) return false;

    // Run once immediately (in case it already has content)
    schedule();

    const obs = new MutationObserver(schedule);
    obs.observe(wrap, { childList: true, characterData: true, subtree: true });
    return true;
  };

  // Try now, otherwise retry briefly (drawer often mounts after load)
  if (attach()) return;

  let tries = 0;
  const timer = setInterval(() => {
    if (attach() || ++tries > 50) clearInterval(timer); // ~5s max
  }, 100);
}


  document.addEventListener('DOMContentLoaded', () => {
    const country = getCountryCode();
    const { mode } = shouldConvert(country);

    // Only convert for Europe or UAE; rest do nothing
    //if (mode === 'UAE') return;

    convertAll(mode);

    observeCartSubtotal(mode); // 👈 that’s it

    // Support cart drawer / ajax updates
    const observer = new MutationObserver((mutations) => {
        for (const m of mutations) {
        m.addedNodes.forEach((node) => {
            if (node.nodeType === 1) convertAll(mode, node);
        });
        }
    });

    observer.observe(document.documentElement, { childList: true, subtree: true });

    // ✅ ADD THIS: re-run when ?variant=4379... changes/appears
    let lastVariant = new URL(window.location.href).searchParams.get('variant');

    const handleVariantUrlChange = () => {
        const currentVariant = new URL(window.location.href).searchParams.get('variant');
        if (currentVariant !== lastVariant) {
        lastVariant = currentVariant;
        requestAnimationFrame(() => convertAll(mode));
        }
    };

    window.addEventListener('popstate', handleVariantUrlChange);

    const _pushState = history.pushState;
    history.pushState = function (...args) {
        const ret = _pushState.apply(this, args);
        handleVariantUrlChange();
        return ret;
    };

    const _replaceState = history.replaceState;
    history.replaceState = function (...args) {
        const ret = _replaceState.apply(this, args);
        handleVariantUrlChange();
        return ret;
    };
    });
})();
